// iter 400g — the server coalesces incremental Airtable syncs (one per 30s
// shared by every open tab). Turn its response into a truthful toast.
export function describeSync(data = {}) {
  if (data.skipped === "recent") {
    const age = data.synced_at ? Math.max(0, Math.round((Date.now() - new Date(data.synced_at).getTime()) / 1000)) : null;
    return age != null ? `Already up to date — synced ${age}s ago` : "Already up to date";
  }
  if (data.skipped === "in_progress") return "Sync already running — refreshing";
  const syncType = data.was_full_sync ? "Full" : "Incremental";
  return `${syncType} sync: ${data.total_synced ?? 0} records (${data.created ?? 0} new, ${data.updated ?? 0} updated)`;
}
